import PropTypes from "prop-types";
import styled from "styled-components";

export const Td = styled.td`
    ${props => props.height && `height: ${props.height};`}
    text-align: ${props => props.align};
    padding: 8px 1px 8px ${props => props.leftPad};
    white-space: ${props => (props.noWrap ? "nowrap" : "auto")};
    color: ${props => (props.negative ? "#c8372d" : "default")};

    @media print {
        i {
            display: none !important;
        }
    }
`;

Td.defaultProps = {
    align: "left",
    leftPad: "8px"
};

Td.propTypes = {
    align: PropTypes.oneOf(["left", "right", "center", "justify"]),
    leftPad: PropTypes.string
};
